module.exports = __webpack_public_path__ + "static/media/multicultural-small.5d39e3c2.mp4";